{
  "version": 1,
  "asset_id": "8fe16873-f238-40de-b1b4-0890a7843ec7",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/8fe16873-f238-40de-b1b4-0890a7843ec7/clip-img_0229.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/8fe16873-f238-40de-b1b4-0890a7843ec7/clip-img_0229.mp4",
  "original_filename": "clip-img_0229.mp4",
  "size": 395315,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T18:34:25Z"
}
